import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { type FC } from 'react';
import { Link } from 'react-router-dom';

import { ADD_CATEGORY_PATH } from '@app/constants';

import { useServiceCategoriesHeader } from '@pages/ServiceCategories/hooks';

export const ServiceCategoriesHeader: FC = () => {
  const { hasUserRightCreateCategory, label, isMobile } =
    useServiceCategoriesHeader();

  if (!hasUserRightCreateCategory) {
    return null;
  }

  return (
    <Link to={ADD_CATEGORY_PATH}>
      <Button
        className={isMobile ? 'full-width' : ''}
        type="primary"
        icon={<PlusOutlined />}
        data-testid="add-category"
      >
        {label}
      </Button>
    </Link>
  );
};
